import * as Sentry from "@sentry/react"
import type { InitSentryArgs } from "./types"
import { shouldIgnoreError } from "./utils"

export function initSentry({
  dsn,
  environment = "development",
  release = "0.0.0",
  ...rest
}: InitSentryArgs) {
  Sentry.init({
    dsn,
    environment,
    release,
    beforeSend: event => (shouldIgnoreError(event) ? null : event),
    ...rest,
  })
}
